let animationObserver;

function parseSeconds(value) {
  const trimmed = (value || "").trim();
  if (!trimmed) return 0;
  if (trimmed.endsWith("ms")) return parseFloat(trimmed) / 1000;
  if (trimmed.endsWith("s")) return parseFloat(trimmed);
  return parseFloat(trimmed) || 0;
}

function getRevealDurationMs(el) {
  if (!el) return 0;

  if (el.hasAttribute("data-line-reveal")) {
    const styles = getComputedStyle(el);
    const lineCount = el.querySelectorAll(".line-mask").length;
    const stagger = parseSeconds(styles.getPropertyValue("--line-stagger")) || 1.2;
    const duration = parseSeconds(styles.getPropertyValue("--line-duration")) || 1.65;
    const lastLineDelay = Math.max(lineCount - 1, 0) * stagger;
    return (lastLineDelay + duration) * 1000;
  }

  if (el.hasAttribute("data-intro-title")) {
    const styles = getComputedStyle(el);
    const wordCount = el.querySelectorAll(".intro-word").length || 1;
    const stagger = parseSeconds(styles.getPropertyValue("--intro-stagger")) || 0.12;
    const duration = parseSeconds(styles.getPropertyValue("--intro-duration")) || 1.25;
    const lastWordDelay = Math.max(wordCount - 1, 0) * stagger;
    return (lastWordDelay + duration) * 1000;
  }

  return 0;
}

function revealElement(el) {
  if (el.hasAttribute("data-intro-title")) {
    splitIntroTitle(el);
  }
  el.classList.add("is-visible");
}

function splitIntroTitle(el) {
  if (el.dataset.introReady === "true") return;
  el.dataset.introReady = "true";

  const wrapText = (text, target) => {
    const parts = text.split(/(\s+)/);
    parts.forEach((part) => {
      if (!part) return;
      if (/^\s+$/.test(part)) {
        target.appendChild(document.createTextNode(part));
        return;
      }

      const word = document.createElement("span");
      word.className = "intro-word";
      word.textContent = part;
      target.appendChild(word);
    });
  };

  const processNode = (node, target) => {
    if (node.nodeType === Node.TEXT_NODE) {
      wrapText(node.textContent, target);
      return;
    }

    if (node.nodeType !== Node.ELEMENT_NODE) return;

    if (node.nodeName === "BR") {
      target.appendChild(document.createElement("br"));
      return;
    }

    const clone = node.cloneNode(false);
    node.childNodes.forEach((child) => processNode(child, clone));
    target.appendChild(clone);
  };

  const inner = document.createElement("span");
  inner.className = "intro-title__inner";
  el.childNodes.forEach((child) => processNode(child, inner));
  el.replaceChildren(inner);

  el.querySelectorAll(".intro-word").forEach((word, index) => {
    word.style.setProperty(
      "--intro-delay",
      `${index * parseSeconds(getComputedStyle(el).getPropertyValue("--intro-stagger") || "0.12s")}s`
    );
  });
}

function setupStaggeredGroup(container) {
  const heading = container.querySelector(
    "[data-line-reveal]:not([data-defer-reveal]), [data-intro-title]:not([data-defer-reveal])"
  );
  const content = container.querySelector("[data-defer-reveal]");

  if (!heading || !content) return null;

  if (heading.hasAttribute("data-intro-title")) {
    splitIntroTitle(heading);
  }

  return { heading, content };
}

function observeCustomAnimations(root = document) {
  const prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;

  const staggerGroups = [];
  root.querySelectorAll("[data-stagger-content-reveal]").forEach((container) => {
    const group = setupStaggeredGroup(container);
    if (group) staggerGroups.push(group);
  });

  root.querySelectorAll("[data-intro-title].js-reveal:not([data-defer-reveal])").forEach((el) => {
    splitIntroTitle(el);
    if (prefersReducedMotion) {
      el.classList.add("is-visible");
    }
  });

  if (prefersReducedMotion) {
    root
      .querySelectorAll("[data-line-reveal].js-line-reveal, [data-defer-reveal]")
      .forEach((el) => el.classList.add("is-visible"));
    return;
  }

  if (!animationObserver) {
    animationObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          const target = entry.target;

          if (target.dataset.staggerGroup === "true") {
            const heading = target.querySelector(
              "[data-line-reveal]:not([data-defer-reveal]), [data-intro-title]:not([data-defer-reveal])"
            );
            const content = target.querySelector("[data-defer-reveal]");

            if (heading) {
              revealElement(heading);
            }

            if (content) {
              const delay = getRevealDurationMs(heading);
              window.setTimeout(() => revealElement(content), delay);
            }

            animationObserver.unobserve(target);
            return;
          }

          revealElement(target);
          animationObserver.unobserve(target);
        });
      },
      { threshold: 0.2 }
    );
  }

  staggerGroups.forEach((group) => {
    const container = group.heading.closest("[data-stagger-content-reveal]");
    if (!container || container.dataset.staggerObserved === "true") return;
    container.dataset.staggerObserved = "true";
    container.dataset.staggerGroup = "true";
    animationObserver.observe(container);
  });

  root
    .querySelectorAll(
      "[data-intro-title].js-reveal:not(.is-visible):not([data-defer-reveal]), [data-line-reveal].js-line-reveal:not(.is-visible):not([data-defer-reveal])"
    )
    .forEach((el) => {
      if (el.closest("[data-stagger-content-reveal]")) return;
      animationObserver.observe(el);
    });
}

document.addEventListener("DOMContentLoaded", () => observeCustomAnimations());
document.addEventListener("shopify:section:load", (event) => {
  observeCustomAnimations(event.target);
});
